/**
 * @generated SignedSource<<ea4b8b951cb9408e754d27bfe7695a43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetArticleTitleArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetArticleTitleArticle";
};
export type helpersGetArticleTitleArticle$key = {
  readonly " $data"?: helpersGetArticleTitleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetArticleTitleArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetArticleTitleArticle"
};

(node as any).hash = "d7b9cb48b9becb434b85d1c2e20a1711";

export default node;
